'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagCnaAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-1.43051e-05 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 -3.27826e-07 20C-3.27826e-07 13.3333 8.97587e-05 6.66667 -1.43051e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-1.43051e-05 0H28V20H-3.27826e-07L-1.43051e-05 0Z",
          fill: "#19BFBF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.7588 13.5176C12.7023 13.4047 12.5869 13.3333 12.4607 13.3333H12.1381C12.0497 13.3333 11.9649 13.2982 11.9024 13.2357L9.43096 10.7643C9.36845 10.7018 9.33333 10.617 9.33333 10.5286V9.47141C9.33333 9.383 9.29821 9.29821 9.2357 9.2357L8.06529 8.06529C8.02257 8.02257 7.99226 7.96904 7.97761 7.91043L7.37771 5.51085C7.35007 5.40029 7.26786 5.31151 7.15974 5.27547L5.35581 4.67416C5.34084 4.66917 5.32625 4.66313 5.31214 4.65607L4.18426 4.09213C4.07133 4.03567 4 3.92025 4 3.79399V3C4 2.81591 4.14924 2.66667 4.33333 2.66667H5.19526C5.28367 2.66667 5.36845 2.70179 5.43096 2.7643L5.90237 3.2357C5.96488 3.29821 6.04966 3.33333 6.13807 3.33333H7.19526C7.28367 3.33333 7.36845 3.29821 7.43096 3.2357L7.90237 2.7643C7.96488 2.70179 8.04967 2.66667 8.13807 2.66667H10.588C10.6397 2.66667 10.6908 2.67871 10.737 2.70186L11.9296 3.29814C11.9759 3.32129 12.0269 3.33333 12.0787 3.33333H13.2546C13.3064 3.33333 13.3574 3.32129 13.4037 3.29814L14.5963 2.70186C14.6426 2.67872 14.6936 2.66667 14.7454 2.66667H17C17.1841 2.66667 17.3333 2.81591 17.3333 3V3.66667C17.3333 3.85076 17.1841 4 17 4H16.3333C16.1492 4 16 4.14924 16 4.33333V5.79399C16 5.92025 16.0713 6.03567 16.1843 6.09213L16.8509 6.42546C17.0726 6.53628 17.3333 6.37512 17.3333 6.12732V5C17.3333 4.8159 17.4826 4.66667 17.6667 4.66667H19C19.1841 4.66667 19.3333 4.8159 19.3333 5C19.3333 5.18409 19.4826 5.33333 19.6667 5.33333H21C21.1841 5.33333 21.3333 5.48257 21.3333 5.66667V6.61257C21.3333 6.6484 21.3276 6.68399 21.3162 6.71798L20.6915 8.59202C20.6752 8.64111 20.6476 8.68572 20.611 8.72231L18.7049 10.6284C18.6796 10.6538 18.6585 10.683 18.6425 10.715L18.0352 11.9296C18.012 11.9759 18 12.0269 18 12.0787V13C18 13.1841 17.8508 13.3333 17.6667 13.3333H17.5393C17.4131 13.3333 17.2977 13.262 17.2412 13.1491L16.7588 12.1843C16.7023 12.0713 16.5869 12 16.4607 12H14.8727C14.7464 12 14.631 12.0713 14.5745 12.1843L14.0745 13.1843C14.0276 13.2781 14.0276 13.3886 14.0745 13.4824L14.5745 14.4824C14.631 14.5953 14.7464 14.6667 14.8727 14.6667H15.8619C15.9503 14.6667 16.0351 14.7018 16.0976 14.7643L17.2357 15.9024C17.2982 15.9649 17.3333 16.0497 17.3333 16.1381V17C17.3333 17.1841 17.1841 17.3333 17 17.3333H16.206C16.0798 17.3333 15.9643 17.262 15.9079 17.1491L15.4255 16.1843C15.369 16.0713 15.2536 16 15.1273 16H14.206C14.0798 16 13.9643 15.9287 13.9079 15.8157L12.7588 13.5176Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagCnaAsset = forwardRef(FlagCnaAsset);

export { VpFlagCnaAsset as default };
